import classes from "../components/ContactBelow.module.css";
import mapImg from "../images/map-marked-alt.png";
function ContactUsBelow() {
  const cards = [
    {
      title: "PRETORIA",
      address: (
        <>
          <p>
            75 Durham Rd <br />
            Centurion <br /> 0157{" "}
          </p>
        </>
      ),

      icon: "map",
    },
    {
      title: "GEORGE",
      address: (
        <>
          <p>
            126 York Street <br /> George <br /> 6530
          </p>
        </>
      ),
      icon: "map",
    },
    {
      title: "WhatsApp",
      contact: "+27 63 068 0075",
      icon: "whatsapp",
    },
    {
      title: "Phone",
      contact: "012 941 9544",
      icon: "headset",
    },
    {
      title: "Email",
      contact: "apply@webridge.co.za",
      icon: "envelope",
    },
  ];

  return (
    <>
      <div className={` mb-2 ${classes.BelowBackground}`}>
        <div className="text-center p-1 text-light">
          <h4>Contact Us</h4>
          <p className="">
            Use the details below to reach us, or alternatively apply for
            bridging finance through the online form
          </p>
        </div>
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((card, index) => (
              <div className="col-lg-2 col-md-3 col-sm-3">
                <div
                  className={`card w-100 text-center p-3 h-100 ${classes.cardBody}`}
                >
                  <div className="container-fluid text-center p-1">
                    {card.icon ? (
                      <i className={`bi bi-${card.icon} ${classes.svg}`}></i>
                    ) : (
                      <img src={mapImg} width={70} alt="..." />
                    )}
                  </div>
                  <div className={`card-body `}>
                    <h5 className="card-title">{card.title}</h5>
                    {card.address ? (
                      <p className="card-text">{card.address}</p>
                    ) : (
                      <p className="card-text">{card.contact}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUsBelow;
